import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/app/[locale]/(seo)/(faceless video)/faceless-video-ai/(default)/components/ExempleCarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/app/[locale]/(seo)/(faceless video)/faceless-video-ai/(default)/components/LandingUtils.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/css/cta.css");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/css/cta2.css");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/css/style.css");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/components/css/astronaut.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/components/pricingNew3.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/autocomplete/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/breadcrumbs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/calendar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/chip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/date-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/date-picker/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/dropdown/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ResizablePanel"] */ "/var/www/html/vexubweb/node_modules/@nextui-org/framer-utils/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/image/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/listbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/navbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/pagination/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/radio/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/ripple/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/scroll-shadow/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/snippet/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/table/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/@nextui-org/user/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/public/images/carousel-icon-01.svg");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/public/images/carousel-icon-02.svg");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/public/images/carousel-icon-03.svg");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/public/images/carousel-icon-04.svg");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/public/images/logovexub.png");
